import FormattableTextField, { IFormattableTextFieldProps } from './FormattableTextField'

export default class DurationTextField extends FormattableTextField {
    public static defaultProps: Partial<IFormattableTextFieldProps> = {
        label: 'Tijd',
        required: true,
        iconProps: { iconName: 'Stopwatch' },
        inputClassName: 'ms-textAlignRight',
    }

    protected filter(value: string = ''): string {
        let separatorPosition = value.indexOf(':')
        // No if-else statement on purpose, because both operations might be triggered.
        // Make sure a colon exists in the entity.
        if (separatorPosition === -1) {
            const hours = value.substring(0, value.length - 2)
            const minutes =
                (value.length < 2 ? new Array(2 - value.length).fill('0').join('') : '') +
                value.substring(value.length - 2)

            value = hours + ':' + minutes
            separatorPosition = value.indexOf(':')
        }
        // Ensure that the minutes has 2 digits at least.
        if (value.length - (separatorPosition + 1) < 2) {
            value = value + new Array(2 - (value.length - (separatorPosition + 1))).fill('0').join('')
        }
        return this.format(value)
    }

    protected format(value: string = ''): string {
        return value
            .replace(/[.,]/, ':') // Allow dots and commas as valid separators.
            .replace(/[^\d:]/, '') // Only accept numbers and colons.
            .replace(/.*?([\d]{0,2}[:][\d]{0,2}).*/, '$1') // Limit the format to HH:MM.
            .replace(/[0]+([\d]+[:])/, '$1') // Remove excess preceding 0.
            .replace(/^[:]/, '0:') // Prepend a 0, if there is only a colon.
    }
}
